import React from 'react'

export const checkbox = (props) => {

    const {
      input,
      label,
      helpText,
      onKeyUp = (e) => {},
      meta: {touched, error},
      disabled,
      required = false,
      addClass
    } = props

    return (
      <div className={'form-group checkbox' + (touched && error ? ' is-invalid' : '') + (addClass ? ' ' + addClass : '') }>
          <div className="form-check">
              <input id={input.name}
                type="checkbox"
                {...input}
                disabled={disabled === true}
                required={required === true}
                checked={input.value}
                className={'form-check-input ' + (touched && error ? 'is-invalid' : '')}/>
            {
              <label htmlFor={input.name} className="form-check-label">
                {label} { required && <span className="mandatory">*</span> }
              </label>
            }
          </div>

          {touched && error && <p className="text-danger"><span>{error}</span></p>}
      </div>
    )
}
